import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));

export const salaryRoutes = [
  {
    page: MainPage,
    path: pathRoutes.salary.parameter,
    screenCode: SCREEN.IP_027,
  },
  {
    page: MainPage,
    path: pathRoutes.salary.tabs.regular,
    screenCode: SCREEN.IP_027,
  },
  {
    page: MainPage,
    path: pathRoutes.salary.tabs.total,
    screenCode: SCREEN.IP_027,
  },
];
